import hrtime from 'browser-process-hrtime'
import 'process'
import 'raf/polyfill'
import 'regenerator-runtime/runtime'
import 'requestidlecallback'
process.hrtime = hrtime as any
